/**============================================================
*   [contactControl]
*   description : お問い合わせフォームのエラー文言処理
============================================================*/
const contactForm = document.getElementById('contactForm');
const path = location.pathname;

if (contactForm) {
  jQuery(document).on('wpcf7invalid', function () {
    jQuery.ajax().always(function () {

      // 既存のエラー文言を削除
      if (jQuery('.c-text-error').length) {
        jQuery('.c-text-error').each(function (index, prev_error) {
          jQuery(prev_error).remove();
        });
      }

      jQuery('.wpcf7-form-control-wrap').each(function (index, el) {
        if (jQuery(el).find('.wpcf7-not-valid-tip').length) {

          // エラー文言用classを追加
          jQuery(el).find('.wpcf7-not-valid-tip').addClass('c-text-error');

          // エラー文言表示位置を変更
          jQuery(el).closest('td').append(jQuery(el).find('.wpcf7-not-valid-tip'));

          // 前の要素のエラー文言と重複していた場合
          jQuery('.wpcf7-not-valid-tip').each(function (index_ch, el_ch) {
            if (jQuery(el_ch).prev().text() == jQuery(el_ch).text()) {
              jQuery(el_ch).remove();
            }
          });

        }
      });
      // 全体メッセージの調整
      if (jQuery('.wpcf7-response-output').length) {
        jQuery('.wpcf7-response-output').addClass('c-text-error');
        jQuery('.wpcf7-response-output').insertBefore(jQuery('#contactFormWrapper'));
      }

      // エラー文言表示時のスクロール処理
      const position = jQuery('.wpcf7-not-valid-tip:first').closest('tr').offset().top;
      const header = jQuery('#js-header').outerHeight();
      jQuery('html, body').animate({
        scrollTop: position - header
      }, 700);
    });
  });

  // 都道府県プルダウンメニューのテキストを隠し入力項目のvalue値に格納
  const address1 = document.getElementById('address1');
  const address1Hidden = document.getElementById('address1Hidden');
  const code = document.getElementById('code');
  if (address1 && address1Hidden && code) {
    jQuery('#code, #address1').change(function () {
      const index = address1.selectedIndex;
      const address1_text = address1.options[index].text;
      address1Hidden.value = address1_text;
    });
  }

  // 確認画面から遷移した場合ボタンのdisabledを解除
  document.addEventListener('DOMContentLoaded', function () {
    const referrer = document.referrer;
    if (referrer.indexOf('/contact/confirm/') != -1) {
      jQuery('.wpcf7-submit').prop('disabled', false);
    }
  });
}

if (path.indexOf('/contact/confirm') !== -1) {
  jQuery(function () {
    //二重送信抑制
    let submitBtn = jQuery("input[type='submit'].wpcf7-submit");
    if (submitBtn) {
      submitBtn.click(function () {
        jQuery(this).css('pointer-events', 'none');
      })
    }
  });
}
